import routerOptions0 from "/vercel/path0/node_modules/.pnpm/nuxt@3.21.6_@parcel+watcher@2.5.6_@types+node@18.19.130_@vue+compiler-sfc@3.5.34_cac@6._66079225ea7e417ec6cbbb3824db86a0/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  strict: false,
  scrollBehaviorType: "smooth",
  hashMode: false
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}